import Collection from './collection.js';
import Position from 'newModels/position.js';

export default class Positions extends Collection {
    url() {
        if (this.company) {
            return this.company.url() + '/positions';
        }

        return `/Positions`;
    }

    initialize(models, {company = null}) {
        super.initialize(...arguments);
        this.model = Position;
        this.company = company;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/positions.js